import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navigation";
import {
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  InputBase,
  IconButton,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuList,
  Popper,
  Paper,
} from "@material-ui/core";
import { Pagination, TextField, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Modal from "@mui/material/Modal";
import SnackbarAlert from "../components/SnackbarAlert";
import Footer from "../components/Footer";
import { makeStyles } from "@material-ui/core/styles";
import API_ENDPOINTS from "../utilities/APIRoutes";
import { AvailableCollectionsContext } from "../contexts/AvailableCollectionsContext";
import { TourContext } from "../contexts/TourContext";
import useDataManagement from "../hooks/useDataManagement";
import ModernUploader from "../components/ModernUploader";
import DocumentsPanel from "../components/DocumentsPanel";
import Fuse from "fuse.js";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.9)",
  },
  centerContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    flexGrow: 1,
    fontFamily: "Raleway, sans-serif",
    padding: theme.spacing(4, 8),
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(7),
      marginTop: theme.spacing(10),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6.5),
      marginTop: theme.spacing(6),
    },
  },
  mainContainer: {
    flexGrow: 0,
    padding: theme.spacing(2.5, 8),
    marginTop: theme.spacing(4),
    width: "100%",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(4),
      marginTop: theme.spacing(10), // Adjust margin for tablets
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(8),
    },
  },
  listContainer: {
    width: "100%",
    maxWidth: 1400,
    // margin: "0 auto",
    // padding: theme.spacing(0, 8),
    // [theme.breakpoints.down("md")]: {
    //   padding: theme.spacing(4),
    // },
    // [theme.breakpoints.down("sm")]: {
    //   padding: theme.spacing(2),
    // },
  },
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      // Changed from sm to md to include tablets
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(2),
    },
  },
  headerTitle: {
    color: "#ffffff",
    fontWeight: "bold",
    fontFamily: "Raleway, sans-serif",
    marginLeft: theme.spacing(-8),
  },
  headerSubtitle: {
    color: "#b0b0b0",
    fontFamily: "Raleway, sans-serif",
    fontSize: "1rem",
    marginTop: theme.spacing(1),
    fontStyle: "italic",
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(2),
  },
  yellowButton: {
    backgroundColor: "#FFC629",
    color: "#000000",
    borderRadius: "8px",
    padding: theme.spacing(1, 3),
    fontWeight: "bold",
    textTransform: "none",
    fontFamily: "Raleway, sans-serif",
    "&:hover": {
      backgroundColor: "#FFC629",
    },
  },
  controlsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      // Ensure stacking on small screens
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  searchBarContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ffffff",
    borderRadius: "5px",
    padding: "4px 16px",
    minWidth: "300px",
    height: "35px",
    [theme.breakpoints.down("sm")]: {
      // Use sm breakpoint to include smaller tablets/large phones
      minWidth: "100%",
    },
  },
  filterTabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "#FFC629",
    },
  },
  tabItem: {
    color: "#ffffff",
    textTransform: "none",
    fontFamily: "Raleway, sans-serif",
    fontSize: "0.9rem",
    fontWeight: "bold",
    minWidth: 100,
    "&.Mui-selected": {
      color: "#FFC629",
    },
  },
  sortButtons: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between", // Spread out on mobile
      marginTop: theme.spacing(1),
    },
  },
  sortIconButton: {
    borderRadius: 5,
    width: 38,
    height: 38,
    transition: "background-color 0.2s",
  },
  listItem: {
    backgroundColor: "#333333",
    borderRadius: "8px",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0.5, 2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#404040",
    },
  },
  listItemTextPrimary: {
    color: "#ffffff",
    fontWeight: "bold",
    fontFamily: "Raleway, sans-serif",
    fontSize: "1rem",
  },
  listItemTextSecondary: {
    color: "#FFC629",
    fontFamily: "Poppins, sans-serif",
    fontSize: "0.8rem",
    marginTop: theme.spacing(0.5),
  },
  iconButton: {
    backgroundColor: "#FFC629",
    borderRadius: "6px",
    padding: 6,
    marginLeft: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#FFD700",
    },
    "&.Mui-disabled": {
      backgroundColor: "#505050",
      color: "#808080",
    },
  },
  dialogPaper: {
    backgroundColor: "#202020",
    color: "#ffffff",
    borderRadius: "14px",
    padding: theme.spacing(2),
    minWidth: "500px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "90%",
    },
  },
  dialogTitle: {
    fontFamily: "Raleway, sans-serif",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "1.2rem",
  },
  formInput: {
    marginBottom: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      marginTop: theme.spacing(1),
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      "& .MuiOutlinedInput-input": {
        fontFamily: "Poppins, sans-serif",
      },
      "& .MuiOutlinedInput-input::placeholder": {
        fontFamily: "Poppins, sans-serif",
        opacity: 1,
      },
    },
    "& .MuiFormHelperText-root": {
      textAlign: "right",
      fontFamily: "Poppins, sans-serif",
      color: "#999",
    },
  },
  modalTitle: {
    textAlign: "center",
    fontFamily: "Raleway, sans-serif",
    fontWeight: "bold",
    color: "white",
    fontSize: "1.5rem",
    marginBottom: theme.spacing(3),
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 500,
    backgroundColor: "#202020",
    borderRadius: "14px",
    padding: theme.spacing(4),
    outline: "none",
  },
  sharedWithList: {
    maxHeight: "18vh",
    overflowY: "auto",
    padding: theme.spacing(1.5),
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "8px",
    marginTop: theme.spacing(2),
  },
  listShare: {
    backgroundColor: "#303030",
    color: "#ffffff",
    marginBottom: "0.4rem",
    borderRadius: 8,
  },
  radioLabel: {
    fontFamily: "Poppins, sans-serif",
  },
}));

function CollectionManagement() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  // -- State Management --
  const [loading, setLoading] = useState(false);
  const [publicCollections, setPublicCollections] = useState([]);
  const [privateCollections, setPrivateCollections] = useState([]);
  const [filterType, setFilterType] = useState("all"); // 'all', 'public', 'private'
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;

  // -- Sorting State --
  const [sortBy, setSortBy] = useState("createdAt"); // 'name' or 'createdAt'
  const [sortOrder, setSortOrder] = useState("desc"); // 'asc' or 'desc'

  // -- Creation Form State --
  const [collectionName, setCollectionName] = useState("");
  const [collectionDescription, setCollectionDescription] = useState("");
  const [collectionType, setCollectionType] = useState("private"); // 'public' or 'private'

  // Database Form State
  const [databaseType, setDatabaseType] = useState("");
  const [dbPuborPriv, setDbPuborPriv] = useState("");
  const [database, setDatabase] = useState("");
  const [host, setHost] = useState("");
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [connectionName, setConnectionName] = useState("");
  const [endpointURL, setEndpointURL] = useState("");
  const [region, setRegion] = useState("");
  const [accessKey, setAccessKey] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [tableName, setTableName] = useState("");
  const [port, setPort] = useState("");

  // -- Modal States --
  const [createCollectionOpen, setCreateCollectionOpen] = useState(false);
  const [createDatabaseOpen, setCreateDatabaseOpen] = useState(false);

  // -- Split Button State --
  const [openSplit, setOpenSplit] = useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const splitOptions = ["Create Collection", "Connect Database"];

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpenSplit(false);
    if (index === 0) setCreateCollectionOpen(true);
    else setCreateDatabaseOpen(true);
  };

  const handleToggleSplit = () => {
    setOpenSplit((prevOpen) => !prevOpen);
  };

  const handleCloseSplit = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenSplit(false);
  };

  const handleClickSplit = () => {
    if (selectedIndex === 0) setCreateCollectionOpen(true);
    else setCreateDatabaseOpen(true);
  };

  const [collectionToDelete, setCollectionToDelete] = useState(null);
  const [collectionToShare, setCollectionToShare] = useState(null);
  const [manageModalOpen, setManageModalOpen] = useState(false);
  const [uploaderOpen, setUploaderOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);

  // -- Sharing State --
  const [shareEmail, setShareEmail] = useState("");
  const [sharedUsers, setSharedUsers] = useState([]);

  // -- Snackbar State --
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // -- Context & Hooks --
  const { updateAvailableCollections } = useContext(
    AvailableCollectionsContext
  );
  const { startTour } = useContext(TourContext);

  const authToken = localStorage.getItem("authToken");
  const userToken = localStorage.getItem("userToken");
  const userId = localStorage.getItem("user_id");
  const userRole = localStorage.getItem("role");

  // -- Helpers --
  const showSnackbar = useCallback((message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }, []);

  useEffect(() => {
    if (location.state?.snackbarMessage) {
      showSnackbar(location.state.snackbarMessage, location.state.snackbarSeverity);
      // Clear state so it doesn't reappear on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state, showSnackbar]);

  // Start collection management tour on first visit
  useEffect(() => {
    const timer = setTimeout(() => {
      startTour("collectionManagement");
    }, 800);
    return () => clearTimeout(timer);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    fetchFiles,
    files,
    selectedFile,
    selectedURL,
    getRootProps,
    getInputProps,
    isDragActive,
    error,
    helperText,
    open,
    fileToDelete,
    handleUploadClick,
    removeFile,
    handleUrlChange,
    handleClickOpen,
    handleClose,
    handleConfirmDelete,
    setSelectedCollections,
    loading: dataManagementLoading,
    handleDownloadFile,
    downloadingFileIds,
  } = useDataManagement(authToken, userToken, showSnackbar);

  const handleCloseSnackbar = () => setSnackbarOpen(false);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp));
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // -- Effects --
  const fetchCollectionsData = useCallback(async () => {
    try {
      const response = await fetch(API_ENDPOINTS.ListCollections, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
          "User-Token": userToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setPrivateCollections(data.message?.privateResults || []);
        setPublicCollections(data.message?.publicResults || []);
      } else {
        console.error("Failed to fetch collections:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching collections:", error);
    }
  }, [authToken, userToken]);

  // -- Effects --
  useEffect(() => {
    // Default privacy settings based on role
    if (userRole === "user") {
      setCollectionType("private");
      setDbPuborPriv("private");
    }
  }, [userRole]);

  useEffect(() => {
    fetchCollectionsData();
  }, [fetchCollectionsData]);

  // -- Sorting Handlers --
  const handleSortByChange = (type) => {
    if (sortBy === type) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(type);
      setSortOrder("asc");
    }
  };

  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  // -- Merged & Filtered List Logic --
  const allCollections = useMemo(() => {
    const pub = publicCollections.map((c) => ({ ...c, isPublic: true }));
    const priv = privateCollections.map((c) => ({ ...c, isPublic: false }));
    return [...pub, ...priv];
  }, [publicCollections, privateCollections]);

  const filteredCollections = useMemo(() => {
    let result = [...allCollections];

    // 1. Filter by Tab
    if (filterType === "public") {
      result = result.filter((c) => c.isPublic);
    } else if (filterType === "private") {
      result = result.filter((c) => !c.isPublic);
    }

    // 2. Filter by Search (Fuse.js)
    if (searchQuery.trim()) {
      const fuse = new Fuse(result, {
        keys: ["name", "description"],
        threshold: 0.4,
      });
      result = fuse.search(searchQuery).map((r) => r.item);
    }

    // 3. Sort
    result.sort((a, b) => {
      let comparison = 0;
      if (sortBy === "name") {
        comparison = a.name.localeCompare(b.name);
      } else if (sortBy === "createdAt") {
        comparison = new Date(a.createdAt) - new Date(b.createdAt);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });

    return result;
  }, [allCollections, filterType, searchQuery, sortBy, sortOrder]);

  // Pagination Logic
  const paginatedCollections = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredCollections.slice(start, start + pageSize);
  }, [filteredCollections, currentPage]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // -- Handlers --

  // Create Collection
  const handleCreateCollection = async () => {
    if (!collectionName.trim() || !collectionType) {
      showSnackbar("Please fill out all required fields.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.CreateCollectionAI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "authorization-token": authToken,
          "user-token": userToken,
        },
        body: JSON.stringify({
          collection_name: collectionName,
          collection_description: collectionDescription,
          collection_type: collectionType,
        }),
      });

      const data = await response.json();
      if (data.success) {
        setCollectionName("");
        setCollectionDescription("");
        if (userRole !== "user") setCollectionType("");
        setCreateCollectionOpen(false);
        fetchCollectionsData();
        showSnackbar("Collection created successfully!", "success");
      } else {
        showSnackbar("Failed to create collection.", "error");
      }
    } catch (err) {
      console.error(err);
      showSnackbar("Something went wrong.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Create Database
  const handleCreateDatabase = async () => {
    if (!databaseType) {
      showSnackbar("Please select a database type.", "error");
      return;
    }
    if (
      (databaseType === "mysql" || databaseType === "postgresql") &&
      (!database || !host || !user || !connectionName)
    ) {
      showSnackbar("Please fill all required fields.", "error");
      return;
    }

    let requestBody = {};
    let endpoint = "";

    // Map fields based on type
    if (databaseType === "mysql" || databaseType === "postgresql") {
      requestBody = {
        db_type: databaseType,
        database,
        host,
        user,
        port,
        password,
        connection_name: connectionName,
        collection_type: dbPuborPriv,
      };
      endpoint = API_ENDPOINTS.SQLDBConnect;
    } else if (databaseType === "mongodb") {
      requestBody = {
        db_type: databaseType,
        database,
        host,
        user,
        password,
        connection_name: connectionName,
        collection_type: dbPuborPriv,
      };
      endpoint = API_ENDPOINTS.NoSQLDBConnect;
    } else if (databaseType === "dynamodb") {
      requestBody = {
        region,
        access_key: accessKey,
        secret_key: secretKey,
        table_name: tableName,
        connection_name: connectionName,
        endpoint_url: endpointURL,
        collection_type: dbPuborPriv,
      };
      endpoint = API_ENDPOINTS.DynamoDBConnect;
    }

    setLoading(true);
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "authorization-token": authToken,
          "user-token": userToken,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const data = await response.json();
        // Update context if available
        if (
          data.available_collections ||
          data.available_tables ||
          data.table_schema
        ) {
          updateAvailableCollections((prev) => ({
            ...prev,
            [connectionName]:
              data.available_collections ||
              data.available_tables ||
              data.table_schema,
          }));
        }

        // Reset
        setDatabase("");
        setHost("");
        setUser("");
        setPassword("");
        setAccessKey("");
        setSecretKey("");
        setTableName("");
        setConnectionName("");
        setEndpointURL("");
        setRegion("");
        setPort("");
        setDatabaseType("");
        setCreateDatabaseOpen(false);
        fetchCollectionsData();
        showSnackbar("Database connected successfully!", "success");
      } else {
        showSnackbar("Failed to connect to database.", "error");
      }
    } catch (err) {
      console.error(err);
      showSnackbar("An error occurred connecting to database.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const handleDeleteCollection = async (id, name, isPublic) => {
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.DeleteCollectionAI, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "authorization-token": authToken,
          "user-token": userToken,
        },
        body: JSON.stringify({ collection_id: id, collection_name: name }),
      });
      if (response.ok) {
        fetchCollectionsData();
        showSnackbar("Collection deleted successfully!", "success");
        setCollectionToDelete(null);
      } else {
        showSnackbar("Failed to delete collection.", "error");
      }
    } catch (err) {
      showSnackbar("Error deleting collection.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Share Logic
  const fetchSharedUsers = async (collection) => {
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINTS.RetrieveCollection, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
          "User-Token": userToken,
        },
        body: JSON.stringify({ id: collection.id }),
      });
      const data = await response.json();
      if (!data.error && data.message?.SharedWith) {
        setSharedUsers(data.message.SharedWith);
      } else {
        setSharedUsers([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleShareCollection = async () => {
    if (!shareEmail.trim()) return showSnackbar("Enter a valid email", "error");
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.ShareUserCollection, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
          "User-Token": userToken,
        },
        body: JSON.stringify({
          user_email: shareEmail,
          collection_id: collectionToShare.id,
        }),
      });
      const data = await response.json();
      if (!data.error) {
        setShareEmail("");
        fetchSharedUsers(collectionToShare);
        showSnackbar("Shared successfully!", "success");
      } else {
        showSnackbar(data.message || "Sharing failed", "error");
      }
    } catch (e) {
      showSnackbar("Error sharing collection", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUnshareUser = async (email) => {
    try {
      const response = await fetch(API_ENDPOINTS.UnshareCollection, {
        method: "POST",
        headers: {
          Authorization: authToken,
          "User-Token": userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_email: email,
          collection_id: collectionToShare.id,
        }),
      });
      const data = await response.json();
      if (!data.error) {
        setSharedUsers((prev) => prev.filter((u) => u !== email));
        showSnackbar("Un-shared successfully!", "success");
      }
    } catch (e) {
      showSnackbar("Error unsharing", "error");
    }
  };

  // -- Render Helpers --
  const renderCreateCollectionDialog = () => (
    <Dialog
      open={createCollectionOpen}
      onClose={() => setCreateCollectionOpen(false)}
      classes={{ paper: classes.dialogPaper }}
    >
      <Typography className={classes.dialogTitle}>
        Create New Collection
      </Typography>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          placeholder="Collection Name"
          value={collectionName}
          onChange={(e) => setCollectionName(e.target.value)}
          className={classes.formInput}
          variant="outlined"
        />
        <TextField
          fullWidth
          placeholder="Description (optional)"
          multiline
          rows={3}
          value={collectionDescription}
          onChange={(e) => setCollectionDescription(e.target.value)}
          className={classes.formInput}
          variant="outlined"
          inputProps={{ maxLength: 128 }}
          helperText={`${collectionDescription.length}/128`}
          style={{ fontFamily: "Poppins, sans-serif", marginTop: 10 }}
        />
        {userRole !== "user" && (
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={collectionType}
              onChange={(e) => setCollectionType(e.target.value)}
            >
              <FormControlLabel
                value="private"
                control={<Radio style={{ color: "#FFC629" }} />}
                label="Private"
                classes={{ label: classes.radioLabel }}
              />
              <FormControlLabel
                value="public"
                control={<Radio style={{ color: "#FFC629" }} />}
                label="Public"
                classes={{ label: classes.radioLabel }}
              />
            </RadioGroup>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center", paddingBottom: 20 }}>
        <Button
          onClick={handleCreateCollection}
          className={classes.yellowButton}
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Collection"}
        </Button>
        <Button
          onClick={() => setCreateCollectionOpen(false)}
          style={{ color: "white", fontFamily: "Raleway, sans-serif" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderCreateDatabaseDialog = () => (
    <Dialog
      open={createDatabaseOpen}
      onClose={() => setCreateDatabaseOpen(false)}
      classes={{ paper: classes.dialogPaper }}
    >
      <Typography className={classes.dialogTitle}>
        Connect to Database
      </Typography>
      <DialogContent>
        <FormControl fullWidth className={classes.formInput} variant="outlined">
          <Select
            value={databaseType}
            onChange={(e) => setDatabaseType(e.target.value)}
            displayEmpty
            style={{ backgroundColor: "white", borderRadius: 8 }}
          >
            <MenuItem value="" disabled style={{ fontFamily: "Poppins, sans-serif" }}>
              Select Database Type
            </MenuItem>
            <MenuItem value="mysql" style={{ fontFamily: "Poppins, sans-serif" }}>MySQL</MenuItem>
            <MenuItem value="postgresql" style={{ fontFamily: "Poppins, sans-serif" }}>PostgreSQL</MenuItem>
            <MenuItem value="mongodb" style={{ fontFamily: "Poppins, sans-serif" }}>MongoDB</MenuItem>
            <MenuItem value="dynamodb" style={{ fontFamily: "Poppins, sans-serif" }}>DynamoDB</MenuItem>
          </Select>
        </FormControl>

        {/* Dynamic Fields based on Type */}
        {(databaseType === "mysql" ||
          databaseType === "postgresql" ||
          databaseType === "mongodb") && (
          <>
            <TextField
              fullWidth
              placeholder="Database Name"
              value={database}
              onChange={(e) => setDatabase(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Host"
              value={host}
              onChange={(e) => setHost(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="User"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Port"
              value={port}
              onChange={(e) => setPort(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
          </>
        )}
        {databaseType === "dynamodb" && (
          <>
            <TextField
              fullWidth
              placeholder="Region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Access Key"
              value={accessKey}
              onChange={(e) => setAccessKey(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Secret Key"
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Table Name"
              value={tableName}
              onChange={(e) => setTableName(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
            <TextField
              fullWidth
              placeholder="Endpoint URL"
              value={endpointURL}
              onChange={(e) => setEndpointURL(e.target.value)}
              className={classes.formInput}
              variant="outlined"
            />
          </>
        )}

        <TextField
          fullWidth
          placeholder="Connection Name"
          value={connectionName}
          onChange={(e) => setConnectionName(e.target.value)}
          className={classes.formInput}
          variant="outlined"
        />

        {userRole !== "user" && (
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={dbPuborPriv}
              onChange={(e) => setDbPuborPriv(e.target.value)}
            >
              <FormControlLabel
                value="private"
                control={<Radio style={{ color: "#FFC629" }} />}
                label="Private"
                classes={{ label: classes.radioLabel }}
              />
              <FormControlLabel
                value="public"
                control={<Radio style={{ color: "#FFC629" }} />}
                label="Public"
                classes={{ label: classes.radioLabel }}
              />
            </RadioGroup>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center", paddingBottom: 20 }}>
        <Button
          onClick={handleCreateDatabase}
          className={classes.yellowButton}
          disabled={loading}
        >
          {loading ? "Connecting..." : "Connect"}
        </Button>
        <Button
          onClick={() => setCreateDatabaseOpen(false)}
          style={{ color: "white" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Box className={classes.root}>
      <Navbar />
      <Box className={classes.centerContent}>
        <Box className={classes.mainContainer}>
          {/* HEADER */}
          <Box className={classes.headerSection} data-tour="cm-header">
            <Box>
              <Typography variant="h4" className={classes.headerTitle}>
                Your Collections
              </Typography>
              <Typography
                variant="subtitle1"
                className={classes.headerSubtitle}
              >
                Manage your public and private collections
              </Typography>
            </Box>
            {/* Action Buttons Removed */}
          </Box>

          <Box
            className={classes.controlsContainer}
            style={{ flexWrap: "wrap", gap: 16 }}
          >
            <Tabs
              value={filterType}
              onChange={(e, v) => {
                setFilterType(v);
                setCurrentPage(1);
              }}
              className={classes.filterTabs}
              textColor="inherit"
              style={{ marginBottom: 0 }}
            >
              <Tab
                label="All Collections"
                value="all"
                className={classes.tabItem}
              />
              <Tab
                label="Public Only"
                value="public"
                className={classes.tabItem}
              />
              <Tab
                label="Private Only"
                value="private"
                className={classes.tabItem}
              />
            </Tabs>

            <Box
              className={classes.searchBarContainer}
              data-tour="cm-search-bar"
              style={{
                flexGrow: 1,
                margin: 0,
                minWidth: 200,
                height: "30px",
                padding: "4px 16px",
              }}
            >
              <SearchRoundedIcon style={{ color: "#757575" }} />
              <InputBase
                placeholder="Search across collections..."
                style={{ marginLeft: 8, flex: 1, fontFamily: "Poppins" }}
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Box>

            <Box style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <Box className={classes.sortButtons} style={{ margin: 0 }}>
                <Tooltip title="Sort by Name">
                  <IconButton
                    onClick={() => handleSortByChange("name")}
                    className={classes.sortIconButton}
                    style={{
                      backgroundColor:
                        sortBy === "name" ? "#FFC629" : "#505050",
                    }}
                  >
                    <SortByAlphaIcon
                      style={{
                        color: sortBy === "name" ? "black" : "#A9A9A9",
                        width: 20,
                        height: 20,
                      }}
                    />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Sort by Date">
                  <IconButton
                    onClick={() => handleSortByChange("createdAt")}
                    className={classes.sortIconButton}
                    style={{
                      backgroundColor:
                        sortBy === "createdAt" ? "#FFC629" : "#505050",
                    }}
                  >
                    <AccessTimeIcon
                      style={{
                        color: sortBy === "createdAt" ? "black" : "#A9A9A9",
                        width: 20,
                        height: 20,
                      }}
                    />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  title={sortOrder === "asc" ? "Ascending" : "Descending"}
                >
                  <IconButton
                    onClick={toggleSortOrder}
                    className={classes.sortIconButton}
                    style={{ backgroundColor: "#FFC629" }}
                  >
                    {sortOrder === "asc" ? (
                      <ArrowUpwardIcon
                        style={{ color: "black", width: 20, height: 20 }}
                      />
                    ) : (
                      <ArrowDownwardIcon
                        style={{ color: "black", width: 20, height: 20 }}
                      />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>

              <React.Fragment>
                <div data-tour="cm-add-button" style={{ display: "inline-flex" }}>
                <ButtonGroup
                  variant="contained"
                  ref={anchorRef}
                  aria-label="split button"
                  style={{
                    backgroundColor: "#FFC629",
                    borderRadius: 8,
                    height: 38,
                    boxShadow: "none",
                  }}
                >
                  <Button
                    onClick={handleClickSplit}
                    style={{
                      backgroundColor: "#FFC629",
                      color: "black",
                      fontWeight: "bold",
                      textTransform: "none",
                      border: "none",
                      fontFamily: "Raleway, sans-serif",
                      fontSize: "1rem",
                    }}
                  >
                    {"+ Add"}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#FFC629",
                      color: "black",
                      border: "none",
                      borderLeft: "1px solid rgba(0,0,0,0.1)",
                      minWidth: 30,
                      padding: 0,
                    }}
                    size="small"
                    aria-controls={openSplit ? "split-button-menu" : undefined}
                    aria-expanded={openSplit ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggleSplit}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                </div>
                <Popper
                  open={openSplit}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                  placement="bottom-end"
                  style={{ zIndex: 10, marginTop: 8 }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-end"
                            ? "right top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleCloseSplit}>
                          <MenuList id="split-button-menu">
                            {splitOptions.map((option, index) => (
                              <MenuItem
                                key={option}
                                selected={index === selectedIndex}
                                onClick={(event) =>
                                  handleMenuItemClick(event, index)
                                }
                                style={{ fontFamily: "Poppins, sans-serif" }}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </React.Fragment>
            </Box>
          </Box>
        </Box>

        {/* LIST */}
        <Box className={classes.listContainer} data-tour="cm-collection-list">
          <List>
            {paginatedCollections.length > 0 ? (
              paginatedCollections.map((collection) => {
                const isOwner = collection.ownerID === userId || userRole === "tenant admin" || userRole === "sys admin";
                return (
                  <Tooltip
                    key={collection.id}
                    title={
                      !isOwner
                        ? "You must be the owner to manage this collection"
                        : ""
                    }
                    placement="top"
                  >
                    <Box component="div">
                      <ListItem
                        button={isOwner}
                        className={classes.listItem}
                        onClick={() => {
                          if (isOwner) {
                            navigate(`/collections/${collection.id}`, {
                              state: { collection },
                            });
                          }
                        }}
                        style={{ cursor: isOwner ? "pointer" : "default" }}
                      >
                        <ListItemText
                          primary={collection.name}
                          secondary={
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{
                                  color: "#b0b0b0",
                                  fontFamily: "Poppins, sans-serif",
                                  fontSize: "0.75rem",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {collection.description || "No description"}
                              </span>
                              <span className={classes.listItemTextSecondary}>
                                {collection.isPublic ? "Public" : "Private"} •
                                Created: {formatDate(collection.createdAt)}
                              </span>
                            </span>
                          }
                          classes={{ primary: classes.listItemTextPrimary }}
                        />
                      </ListItem>
                    </Box>
                  </Tooltip>
                );
              })
            ) : (
              <Typography
                style={{
                  color: "#999",
                  textAlign: "center",
                  marginTop: 40,
                  fontFamily: "Raleway, sans-serif",
                  justifyContent: "center",
                }}
              >
                Your collections will appear here.
              </Typography>
            )}
          </List>
        </Box>
        {/* PAGINATION */}
        {filteredCollections.length > pageSize && (
          <Box display="flex" justifyContent="center" marginTop={4}>
            <Pagination
              count={Math.ceil(filteredCollections.length / pageSize)}
              page={currentPage}
              onChange={handlePageChange}
              sx={{
                display: "inline-flex",
                backgroundColor: "#FFC629",
                borderRadius: 1,
                width: "fit-content",
              }}
              size="small"
              shape="rounded"
            />
          </Box>
        )}
        {/* </Box> */}

        {/* --- DIALOGS --- */}
        {renderCreateCollectionDialog()}
        {renderCreateDatabaseDialog()}

        {/* Delete Confirmation Modal */}
        {collectionToDelete && (
          <Modal
            open={Boolean(collectionToDelete)}
            onClose={() => setCollectionToDelete(null)}
          >
            <Box className={classes.modal}>
              <Typography className={classes.modalTitle}>
                Are you sure you want to delete{" "}
                <span style={{ color: "#FFC629" }}>
                  {collectionToDelete.name}
                </span>
                ?
              </Typography>
              <Box display="flex" justifyContent="center" gap={2}>
                <Button
                  onClick={() =>
                    handleDeleteCollection(
                      collectionToDelete.id,
                      collectionToDelete.name,
                      collectionToDelete.isPublic
                    )
                  }
                  className={classes.yellowButton}
                >
                  {loading ? "Deleting..." : "Delete"}
                </Button>
                <Button
                  onClick={() => setCollectionToDelete(null)}
                  style={{ color: "white" }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Modal>
        )}

        {/* Share Modal */}
        {collectionToShare && (
          <Modal
            open={Boolean(collectionToShare)}
            onClose={() => setCollectionToShare(null)}
          >
            <Box className={classes.modal}>
              <Typography className={classes.modalTitle}>
                Share{" "}
                <span style={{ color: "#FFC629" }}>
                  {collectionToShare.name}
                </span>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="User Email"
                value={shareEmail}
                onChange={(e) => setShareEmail(e.target.value)}
                className={classes.formInput}
              />

              <Typography
                style={{ color: "white", marginTop: 20, fontWeight: "bold" }}
              >
                Shared with:
              </Typography>
              <Box className={classes.sharedWithList}>
                {loading ? (
                  <Typography style={{ color: "white" }}>Loading...</Typography>
                ) : sharedUsers.length > 0 ? (
                  <List>
                    {sharedUsers.map((u, i) => (
                      <ListItem key={i} className={classes.listShare}>
                        <ListItemText primary={u} />
                        <IconButton onClick={() => handleUnshareUser(u)}>
                          <RemoveCircleOutlineRoundedIcon
                            sx={{ color: "#797c7f" }}
                          />
                        </IconButton>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography style={{ color: "#aaa", fontSize: "0.8rem" }}>
                    No users yet.
                  </Typography>
                )}
              </Box>

              <Box display="flex" justifyContent="center" gap={2} marginTop={3}>
                <Button
                  onClick={handleShareCollection}
                  className={classes.yellowButton}
                >
                  Share
                </Button>
                <Button
                  onClick={() => setCollectionToShare(null)}
                  style={{ color: "white" }}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </Modal>
        )}

        {/* Manage/Documents Modal */}
        {selectedCollection && (
          <Modal
            open={manageModalOpen}
            onClose={() => setManageModalOpen(false)}
          >
            <Box className={classes.modal} style={{ maxWidth: 800 }}>
              <Typography className={classes.modalTitle}>
                Manage Documents in{" "}
                <span style={{ color: "#FFC629" }}>
                  {selectedCollection.name}
                </span>
              </Typography>
              <DocumentsPanel
                files={files}
                handleClickOpen={handleClickOpen}
                open={open}
                handleClose={handleClose}
                fileToDelete={fileToDelete}
                handleConfirmDelete={() =>
                  handleConfirmDelete(selectedCollection.id)
                }
                loading={dataManagementLoading}
                onAddClick={() => setUploaderOpen(true)}
                onDownload={(file) =>
                  handleDownloadFile(file, selectedCollection.id)
                }
                downloadingFileIds={downloadingFileIds}
              />
              <Box display="flex" justifyContent="center" marginTop={2}>
                <Button
                  onClick={() => setManageModalOpen(false)}
                  style={{ color: "white" }}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </Modal>
        )}

        {/* Uploader Modal */}
        {selectedCollection && (
          <Modal open={uploaderOpen} onClose={() => setUploaderOpen(false)}>
            <ModernUploader
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              isDragActive={isDragActive}
              files={selectedFile}
              url={selectedURL}
              onRemoveFile={removeFile}
              onUrlChange={handleUrlChange}
              onUpload={async () => {
                await handleUploadClick();
                setUploaderOpen(false);
                if (selectedCollection) fetchFiles([selectedCollection.id]);
              }}
              loading={dataManagementLoading}
              error={error}
              helperText={helperText}
              isModal={true}
              onCancel={() => setUploaderOpen(false)}
            />
          </Modal>
        )}

        <SnackbarAlert
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleCloseSnackbar}
        />
      </Box>
      <Footer />
    </Box>
  );
}

export default CollectionManagement;
